/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContractPayoutDateDto } from './contractPayoutDateDto.model';


export interface ContractOwnerParamRequestDto { 
    contractId?: number;
    documentNote?: string;
    paymentToPartnerSubjectId?: number;
    payoutDates?: Array<ContractPayoutDateDto>;
    priceAdd?: number;
    priceContract: number;
    representativeId?: number;
    splitSjmPayments: boolean;
    subjectId?: number;
    taxConcerned: boolean;
    taxOwner?: number;
    taxOwnerAdd?: number;
}

